<template>
	<div class="award__section">
		<div class="award__search" v-if="pageData.category === 'firstCategory'">
			<Selector
				v-model="selectId"
				:option-list="awardList"
				value-key="id"
				@input="search($event)"
			/>
		</div>
		<div v-if="pageData.category !== 'firstCategory'" class="award__route">
			<span class="award__route-name">
				<router-link class="link" :to="'/product/beauty-awards'"
					>HOME</router-link
				>
			</span>
			<span class="award__route-name">
				<router-link class="link" :to="firstCategoryLink">
					{{ firstCategory.hitText }}
				</router-link>
			</span>
			<span
				class="award__route-name"
				v-if="pageData.category === 'secondCategory'"
			>
				{{ firstCategory.categoryText || '-' }}
			</span>

			<template v-if="pageData.category === 'thirdCategory'">
				<span class="award__route-name">
					<router-link class="link" :to="secondCategoryLink">
						{{ firstCategory.categoryText }}
					</router-link>
				</span>
				<span class="award__route-name">{{
					secondCategory.categoryText
				}}</span>
			</template>

			<template v-if="pageData.category === 'mappingProduct'">
				<span class="award__route-name">
					<router-link class="link" :to="secondCategoryLink">
						{{ firstCategory.categoryText }}
					</router-link>
				</span>
				<span class="award__route-name">
					<router-link class="link" :to="thirdCategoryLink">
						{{ secondCategory.categoryText }}
					</router-link>
				</span>
				<span class="award__route-name">{{
					thirdCategory.categoryText
				}}</span>
			</template>
		</div>
		<AwardCategoryAdd
			:awardId="awardId"
			:categoryName="pageData.category"
			:firstCategoryText="firstCategory.categoryText"
			:secondCategoryText="secondCategory.categoryText"
			:thirdCategoryText="thirdCategory.categoryText"
		/>
		<AwardFirstCategory
			v-if="pageData.category === 'firstCategory'"
			:awardId="awardId"
		/>
		<AwardSecondCategory
			v-if="pageData.category === 'secondCategory'"
			:awardId="awardId"
		/>
		<AwardThirdCategory
			v-if="pageData.category === 'thirdCategory'"
			:awardId="awardId"
		/>
		<AwardProductMapping
			v-if="pageData.category === 'mappingProduct'"
			:awardId="awardId"
		/>
	</div>
</template>
<script>
	import Selector from '@/components/Selector';
	import AwardFirstCategory from '@/components/product/AwardFirstCategory.vue';
	import AwardCategoryAdd from '@/components/product/AwardCategoryAdd.vue';
	import { mapState } from 'vuex';
	import AwardSecondCategory from '@/components/product/AwardSecondCategory.vue';
	import AwardThirdCategory from '@/components/product/AwardThirdCategory.vue';
	import AwardProductMapping from '@/components/product/AwardProductMapping.vue';

	export default {
		name: 'ManageBeautyAwards',
		data() {
			return {
				awardId: 0,
				awardName: '',
				selectId: '',
				awardList: [],
				idHitProduct: '',
			};
		},
		components: {
			Selector,
			AwardFirstCategory,
			AwardCategoryAdd,
			AwardSecondCategory,
			AwardThirdCategory,
			AwardProductMapping,
		},
		computed: {
			...mapState({
				beautyAwardList: state => state.award.beautyAwardList,
				firstCategoryList: state => state.award.firstCategoryList,
				secondCategoryList: state => state.award.secondCategoryList,
				firstCategory: state => state.award.firstCategory,
				secondCategory: state => state.award.secondCategory,
				thirdCategory: state => state.award.thirdCategory,
			}),
			pageData() {
				return this.$route.params;
			},
			firstCategoryLink() {
				return `/product/manage-awards/firstCategory?idHitProduct=${this.awardId}`;
			},
			secondCategoryLink() {
				return `/product/manage-awards/secondCategory?idHitProduct=${this.awardId}&idHitCategory=${this.firstCategory.idHitCategory}`;
			},
			thirdCategoryLink() {
				return `/product/manage-awards/thirdCategory?idHitProduct=${this.awardId}&idHitCategory=${this.secondCategory.idHitCategory}`;
			},
		},
		watch: {
			awardId() {
				this.selectId = this.awardId;
				this.getData();
			},
			async pageData() {
				const { category } = this.pageData;
				const idHitProduct = Number(this.$route.query.idHitProduct);

				if (category === 'firstCategory') {
					this.awardId = idHitProduct;
					await this.getfirstCategory();
				}

				if (category === 'secondCategory') {
					this.awardId = idHitProduct;
					await this.getSecondCategory();
				}

				if (category === 'thirdCategory') {
					this.awardId = idHitProduct;
					await this.getThirdCategory();
				}

				if (category === 'mappingProduct') {
					this.awardId = idHitProduct;
					await this.getMappinCategory();
				}
			},
			$route(to, from) {
				if (to.path !== from.path) {
					this.getData();
				}
			},
		},
		async created() {
			await this.$store.dispatch('award/setApiData');
			this.awardList = this.beautyAwardList.map(item => {
				return {
					id: item.idHitProducts,
					name: item.hitText,
				};
			});

			if (this.$route.query.idHitProduct) {
				this.selectId = this.$route.query.idHitProduct;
			}

			await this.getData();
		},

		methods: {
			async search(id) {
				this.awardId = id;
				this.$router.replace({ query: { idHitProduct: this.awardId } });
				await this.getfirstCategory();
			},
			async getfirstCategory() {
				await this.$store.dispatch(
					'award/getFirstCategory',
					this.awardId
				);
			},
			async getSecondCategory() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getSecondCategory', {
					idHitProduct,
					idHitCategory,
				});
			},
			async getThirdCategory() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getThirdCategory', {
					idHitProduct,
					idHitCategory,
				});
			},
			async getMappinCategory() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getMappinCategory', {
					idHitProduct,
					idHitCategory,
				});
			},
			async getData() {
				const { category } = this.pageData;
				const idHitProduct = Number(this.$route.query.idHitProduct);

				switch (category) {
					case 'firstCategory':
						this.awardId =
							idHitProduct ||
							this.beautyAwardList[0].idHitProducts;
						await this.getfirstCategory();
						break;
					case 'secondCategory':
						this.awardId = idHitProduct;
						await this.getSecondCategory();
						break;
					case 'thirdCategory':
						this.awardId = idHitProduct;
						await this.getThirdCategory();
						break;
					case 'mappingProduct':
						this.awardId = idHitProduct;
						await this.getMappinCategory();
						break;
					default:
						break;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.award {
		&__section {
			min-height: 630px;
		}
		&__search {
			margin-top: 20px;
			display: flex;
			justify-content: flex-end;
		}
		&__route {
			display: inline-block;
			padding: 10px 20px;
			margin-top: 30px;
			font-size: 16px;
			background-color: #f5f5f5;
			border-radius: 6px;
		}
		&__route-name {
			display: inline-block;
			& + & {
				margin-left: 10px;
				&:before {
					content: '/ ';
					margin-right: 10px;
				}
			}
		}
	}
</style>
